<template>
    <div>
        <v-container class="bg" fluid>
            <v-row
            align="center"
            justify="center"
            no-gutters
            >
                <v-col cols="12">
                    <flightSearch @startLoad="loading = true" @endLoad="loading = false" />
                </v-col>
            </v-row>
        </v-container>
        <v-row v-if="loading" class="progress-row" justify="center" align="center">
            <v-progress-circular
            :size="70"
            :width="7"
            color="indigo"
            indeterminate
            ></v-progress-circular>
        </v-row>
    </div>
</template>

<script>
import flightSearch from '../components/flightSearch.vue'
export default {
  title: 'Fare33-Flight search',
  components: {
    flightSearch
  },
  data () {
    return {
      loading: false
    }
  }
}
</script>

<style>
    .progress-row {
        height: 40vh;
    }
</style>
